import React from 'react';
import { Shield, AlertTriangle, Zap, FileText } from 'lucide-react';
import CTASection from '../../components/CTASection';
import ServiceHeroForm from '../../components/ServiceHeroForm';

const DMCAPage = () => {
  return (
    <div>
      <div className="bg-gradient-to-br from-gray-900 via-black to-gray-900 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h1 className="text-5xl font-bold mb-6">Digital Millennium Copyright Act <span className="text-[#168356]">(DMCA)</span></h1>
            <p className="text-xl text-gray-300 max-w-3xl">Fast and effective DMCA takedown notices to remove infringing content from websites, search engines, and online platforms.</p>
          </div>
          <ServiceHeroForm title="Start Your DMCA Takedown" buttonText="Start Takedown" />
        </div>
      </div>
      <div className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto space-y-6 text-lg text-gray-700">
            <p>The DMCA provides a powerful tool to quickly remove infringing content from online platforms. When your copyrighted work appears on websites, search engines, social media, or file-sharing services without permission, we file DMCA takedown notices demanding immediate removal.</p>
            <p>Our DMCA service includes identifying infringing content, preparing legally compliant takedown notices, filing with platforms and search engines, following up on non-compliance, and handling counter-notifications. Most content is removed within 24-48 hours.</p>
          </div>
        </div>
      </div>
      <div className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="bg-white rounded-xl p-6 text-center">
              <Zap className="w-12 h-12 text-[#168356] mx-auto mb-4" />
              <h3 className="text-xl font-bold mb-3">Fast Removal</h3>
              <p className="text-gray-700 text-sm">Content removed within 24-48 hours</p>
            </div>
            <div className="bg-white rounded-xl p-6 text-center">
              <FileText className="w-12 h-12 text-[#168356] mx-auto mb-4" />
              <h3 className="text-xl font-bold mb-3">Legally Compliant</h3>
              <p className="text-gray-700 text-sm">Properly formatted DMCA notices</p>
            </div>
            <div className="bg-white rounded-xl p-6 text-center">
              <Shield className="w-12 h-12 text-[#168356] mx-auto mb-4" />
              <h3 className="text-xl font-bold mb-3">Multiple Platforms</h3>
              <p className="text-gray-700 text-sm">File with Google, social media, hosting companies</p>
            </div>
            <div className="bg-white rounded-xl p-6 text-center">
              <AlertTriangle className="w-12 h-12 text-[#168356] mx-auto mb-4" />
              <h3 className="text-xl font-bold mb-3">Counter-Notice Response</h3>
              <p className="text-gray-700 text-sm">Handle disputes professionally</p>
            </div>
          </div>
        </div>
      </div>
      <CTASection />
    </div>
  );
};

export default DMCAPage;